import * as React from 'react';
import { FieldWrapper } from '@progress/kendo-react-form';
import { Label, Error, Hint } from '@progress/kendo-react-labels';
import { MaskedTextBox } from '@progress/kendo-react-inputs';
// eslint-disable-next-line no-unused-vars
import BaseFormControl from './BaseFormControl';

/**
 * A phone number form field.
 *
 * @typedef {React.ComponentProps<BaseFormControl>} BaseFieldRenderProps
 * @typedef {React.PropsWithoutRef<MaskedTextBox>} TelerikMaskedTextBox
 *
 * @param {BaseFieldRenderProps & TelerikMaskedTextBox} fieldRenderProps
 * @returns {React.ReactElement} Phone number form field.
 */
export const FormPhoneNumber = (fieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    wrapperStyle,
    onChange,
    readOnly,
    value,
    ...props
  } = fieldRenderProps;

  const showValidationMessage = touched && validationMessage;
  const showHint = !showValidationMessage && hint;
  const hintId = showHint ? `${id}_hint` : '';
  const errorId = showValidationMessage ? `${id}_error` : '';
  const labelId = label ? `${id}_label` : '';

  const getCleanPhoneValue = (value) => value;

  const getDirtyPhoneValue = (value) => value;

  return (
    <FieldWrapper style={wrapperStyle}>
      <Label id={labelId} editorId={id} editorValid={valid} editorDisabled={disabled}>
        {label}
      </Label>

      <MaskedTextBox
        {...props}
        ariaLabelledBy={labelId}
        ariaDescribedBy={`${hintId} ${errorId}`}
        valid={valid}
        id={id}
        disabled={disabled}
        mask="+99A (000) 000-0000"
        defaultValue={value ? getDirtyPhoneValue(value) : '+  1'}
        maskRules={{ A: /[1-9]/ }}
        onChange={(e) => {
          if (!e.target?.validity?.valid) {
            return;
          }
          e.value = getCleanPhoneValue(e.value);
          onChange(e);
        }}
      />

      {showHint && <Hint id={hintId}>{hint}</Hint>}
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </FieldWrapper>
  );
};
